var Vn = Object.defineProperty;
var Xn = (e, t, r) => t in e ? Vn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var H = (e, t, r) => Xn(e, typeof t != "symbol" ? t + "" : t, r);
import $, { forwardRef as Gn, useImperativeHandle as qn, Fragment as Jn, useMemo as tt, useRef as $t, useReducer as Qn, useEffect as ar, useCallback as oe, Component as Ht, PureComponent as Zn, createRef as pr } from "react";
import C from "prop-types";
function Cr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var hr = { exports: {} }, wt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function eo() {
  if (Mr) return wt;
  Mr = 1;
  var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(p, f, c) {
    var h, g = {}, w = null, b = null;
    c !== void 0 && (w = "" + c), f.key !== void 0 && (w = "" + f.key), f.ref !== void 0 && (b = f.ref);
    for (h in f) o.call(f, h) && !i.hasOwnProperty(h) && (g[h] = f[h]);
    if (p && p.defaultProps) for (h in f = p.defaultProps, f) g[h] === void 0 && (g[h] = f[h]);
    return { $$typeof: t, type: p, key: w, ref: b, props: g, _owner: a.current };
  }
  return wt.Fragment = r, wt.jsx = l, wt.jsxs = l, wt;
}
var _t = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function to() {
  return Ur || (Ur = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), p = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), R = Symbol.iterator, M = "@@iterator";
    function B(n) {
      if (n === null || typeof n != "object")
        return null;
      var s = R && n[R] || n[M];
      return typeof s == "function" ? s : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function j(n) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), d = 1; d < s; d++)
          u[d - 1] = arguments[d];
        $e("error", n, u);
      }
    }
    function $e(n, s, u) {
      {
        var d = I.ReactDebugCurrentFrame, _ = d.getStackAddendum();
        _ !== "" && (s += "%s", u = u.concat([_]));
        var x = u.map(function(m) {
          return String(m);
        });
        x.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, x);
      }
    }
    var Ge = !1, Pe = !1, qe = !1, ae = !1, Te = !1, ie;
    ie = Symbol.for("react.module.reference");
    function ge(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === o || n === i || Te || n === a || n === c || n === h || ae || n === b || Ge || Pe || qe || typeof n == "object" && n !== null && (n.$$typeof === w || n.$$typeof === g || n.$$typeof === l || n.$$typeof === p || n.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === ie || n.getModuleId !== void 0));
    }
    function Je(n, s, u) {
      var d = n.displayName;
      if (d)
        return d;
      var _ = s.displayName || s.name || "";
      return _ !== "" ? u + "(" + _ + ")" : u;
    }
    function ye(n) {
      return n.displayName || "Context";
    }
    function U(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            var s = n;
            return ye(s) + ".Consumer";
          case l:
            var u = n;
            return ye(u._context) + ".Provider";
          case f:
            return Je(n, n.render, "ForwardRef");
          case g:
            var d = n.displayName || null;
            return d !== null ? d : U(n.type) || "Memo";
          case w: {
            var _ = n, x = _._payload, m = _._init;
            try {
              return U(m(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, N = 0, Ie, xe, ve, z, ke, Ce, ue;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function fe() {
      {
        if (N === 0) {
          Ie = console.log, xe = console.info, ve = console.warn, z = console.error, ke = console.group, Ce = console.groupCollapsed, ue = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        N++;
      }
    }
    function Qe() {
      {
        if (N--, N === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, n, {
              value: Ie
            }),
            info: P({}, n, {
              value: xe
            }),
            warn: P({}, n, {
              value: ve
            }),
            error: P({}, n, {
              value: z
            }),
            group: P({}, n, {
              value: ke
            }),
            groupCollapsed: P({}, n, {
              value: Ce
            }),
            groupEnd: P({}, n, {
              value: ue
            })
          });
        }
        N < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = I.ReactCurrentDispatcher, pe;
    function Q(n, s, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (_) {
            var d = _.stack.trim().match(/\n( *(at )?)/);
            pe = d && d[1] || "";
          }
        return `
` + pe + n;
      }
    }
    var he = !1, X;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      X = new Se();
    }
    function Z(n, s) {
      if (!n || he)
        return "";
      {
        var u = X.get(n);
        if (u !== void 0)
          return u;
      }
      var d;
      he = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = V.current, V.current = null, fe();
      try {
        if (s) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (Y) {
              d = Y;
            }
            Reflect.construct(n, [], m);
          } else {
            try {
              m.call();
            } catch (Y) {
              d = Y;
            }
            n.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Y) {
            d = Y;
          }
          n();
        }
      } catch (Y) {
        if (Y && d && typeof Y.stack == "string") {
          for (var v = Y.stack.split(`
`), T = d.stack.split(`
`), D = v.length - 1, O = T.length - 1; D >= 1 && O >= 0 && v[D] !== T[O]; )
            O--;
          for (; D >= 1 && O >= 0; D--, O--)
            if (v[D] !== T[O]) {
              if (D !== 1 || O !== 1)
                do
                  if (D--, O--, O < 0 || v[D] !== T[O]) {
                    var A = `
` + v[D].replace(" at new ", " at ");
                    return n.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", n.displayName)), typeof n == "function" && X.set(n, A), A;
                  }
                while (D >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = x, Qe(), Error.prepareStackTrace = _;
      }
      var J = n ? n.displayName || n.name : "", bt = J ? Q(J) : "";
      return typeof n == "function" && X.set(n, bt), bt;
    }
    function Ze(n, s, u) {
      return Z(n, !1);
    }
    function et(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(n, s, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Z(n, et(n));
      if (typeof n == "string")
        return Q(n);
      switch (n) {
        case c:
          return Q("Suspense");
        case h:
          return Q("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            return Ze(n.render);
          case g:
            return ee(n.type, s, u);
          case w: {
            var d = n, _ = d._payload, x = d._init;
            try {
              return ee(x(_), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, re = {}, me = I.ReactDebugCurrentFrame;
    function G(n) {
      if (n) {
        var s = n._owner, u = ee(n.type, n._source, s ? s.type : null);
        me.setExtraStackFrame(u);
      } else
        me.setExtraStackFrame(null);
    }
    function Oe(n, s, u, d, _) {
      {
        var x = Function.call.bind(te);
        for (var m in n)
          if (x(n, m)) {
            var v = void 0;
            try {
              if (typeof n[m] != "function") {
                var T = Error((d || "React class") + ": " + u + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              v = n[m](s, m, d, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              v = D;
            }
            v && !(v instanceof Error) && (G(_), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", u, m, typeof v), G(null)), v instanceof Error && !(v.message in re) && (re[v.message] = !0, G(_), j("Failed %s type: %s", u, v.message), G(null));
          }
      }
    }
    var ft = Array.isArray;
    function be(n) {
      return ft(n);
    }
    function pt(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function y(n) {
      try {
        return S(n), !1;
      } catch {
        return !0;
      }
    }
    function S(n) {
      return "" + n;
    }
    function F(n) {
      if (y(n))
        return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(n)), S(n);
    }
    var k = I.ReactCurrentOwner, K = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, se, ne, ce;
    ce = {};
    function Fe(n) {
      if (te.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Ae(n) {
      if (te.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Re(n, s) {
      if (typeof n.ref == "string" && k.current && s && k.current.stateNode !== s) {
        var u = U(k.current.type);
        ce[u] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(k.current.type), n.ref), ce[u] = !0);
      }
    }
    function Me(n, s) {
      {
        var u = function() {
          se || (se = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Ue(n, s) {
      {
        var u = function() {
          ne || (ne = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Ne = function(n, s, u, d, _, x, m) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: u,
        props: m,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function Le(n, s, u, d, _) {
      {
        var x, m = {}, v = null, T = null;
        u !== void 0 && (F(u), v = "" + u), Ae(s) && (F(s.key), v = "" + s.key), Fe(s) && (T = s.ref, Re(s, _));
        for (x in s)
          te.call(s, x) && !K.hasOwnProperty(x) && (m[x] = s[x]);
        if (n && n.defaultProps) {
          var D = n.defaultProps;
          for (x in D)
            m[x] === void 0 && (m[x] = D[x]);
        }
        if (v || T) {
          var O = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          v && Me(m, O), T && Ue(m, O);
        }
        return Ne(n, v, T, _, d, k.current, m);
      }
    }
    var we = I.ReactCurrentOwner, ht = I.ReactDebugCurrentFrame;
    function q(n) {
      if (n) {
        var s = n._owner, u = ee(n.type, n._source, s ? s.type : null);
        ht.setExtraStackFrame(u);
      } else
        ht.setExtraStackFrame(null);
    }
    var Be;
    Be = !1;
    function He(n) {
      return typeof n == "object" && n !== null && n.$$typeof === t;
    }
    function dt() {
      {
        if (we.current) {
          var n = U(we.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Jt(n) {
      return "";
    }
    var gt = {};
    function Qt(n) {
      {
        var s = dt();
        if (!s) {
          var u = typeof n == "string" ? n : n.displayName || n.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function yt(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var u = Qt(s);
        if (gt[u])
          return;
        gt[u] = !0;
        var d = "";
        n && n._owner && n._owner !== we.current && (d = " It was passed a child from " + U(n._owner.type) + "."), q(n), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, d), q(null);
      }
    }
    function vt(n, s) {
      {
        if (typeof n != "object")
          return;
        if (be(n))
          for (var u = 0; u < n.length; u++) {
            var d = n[u];
            He(d) && yt(d, s);
          }
        else if (He(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var _ = B(n);
          if (typeof _ == "function" && _ !== n.entries)
            for (var x = _.call(n), m; !(m = x.next()).done; )
              He(m.value) && yt(m.value, s);
        }
      }
    }
    function Zt(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === g))
          u = s.propTypes;
        else
          return;
        if (u) {
          var d = U(s);
          Oe(u, n.props, "prop", d, n);
        } else if (s.PropTypes !== void 0 && !Be) {
          Be = !0;
          var _ = U(s);
          j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function er(n) {
      {
        for (var s = Object.keys(n.props), u = 0; u < s.length; u++) {
          var d = s[u];
          if (d !== "children" && d !== "key") {
            q(n), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), q(null);
            break;
          }
        }
        n.ref !== null && (q(n), j("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
      }
    }
    function mt(n, s, u, d, _, x) {
      {
        var m = ge(n);
        if (!m) {
          var v = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Jt();
          T ? v += T : v += dt();
          var D;
          n === null ? D = "null" : be(n) ? D = "array" : n !== void 0 && n.$$typeof === t ? (D = "<" + (U(n.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : D = typeof n, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, v);
        }
        var O = Le(n, s, u, _, x);
        if (O == null)
          return O;
        if (m) {
          var A = s.children;
          if (A !== void 0)
            if (d)
              if (be(A)) {
                for (var J = 0; J < A.length; J++)
                  vt(A[J], n);
                Object.freeze && Object.freeze(A);
              } else
                j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vt(A, n);
        }
        return n === o ? er(O) : Zt(O), O;
      }
    }
    function tr(n, s, u) {
      return mt(n, s, u, !0);
    }
    function rr(n, s, u) {
      return mt(n, s, u, !1);
    }
    var nr = rr, or = tr;
    _t.Fragment = o, _t.jsx = nr, _t.jsxs = or;
  }()), _t;
}
process.env.NODE_ENV === "production" ? hr.exports = eo() : hr.exports = to();
var E = hr.exports, ro = Object.defineProperty, no = (e, t, r) => t in e ? ro(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, dr = (e, t, r) => no(e, typeof t != "symbol" ? t + "" : t, r), gr = { exports: {} }, xt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function oo() {
  if (Nr) return xt;
  Nr = 1;
  var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(p, f, c) {
    var h, g = {}, w = null, b = null;
    c !== void 0 && (w = "" + c), f.key !== void 0 && (w = "" + f.key), f.ref !== void 0 && (b = f.ref);
    for (h in f) o.call(f, h) && !i.hasOwnProperty(h) && (g[h] = f[h]);
    if (p && p.defaultProps) for (h in f = p.defaultProps, f) g[h] === void 0 && (g[h] = f[h]);
    return { $$typeof: t, type: p, key: w, ref: b, props: g, _owner: a.current };
  }
  return xt.Fragment = r, xt.jsx = l, xt.jsxs = l, xt;
}
var Pt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function ao() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), p = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), R = Symbol.iterator, M = "@@iterator";
    function B(n) {
      if (n === null || typeof n != "object")
        return null;
      var s = R && n[R] || n[M];
      return typeof s == "function" ? s : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function j(n) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), d = 1; d < s; d++)
          u[d - 1] = arguments[d];
        $e("error", n, u);
      }
    }
    function $e(n, s, u) {
      {
        var d = I.ReactDebugCurrentFrame, _ = d.getStackAddendum();
        _ !== "" && (s += "%s", u = u.concat([_]));
        var x = u.map(function(m) {
          return String(m);
        });
        x.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, x);
      }
    }
    var Ge = !1, Pe = !1, qe = !1, ae = !1, Te = !1, ie;
    ie = Symbol.for("react.module.reference");
    function ge(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === o || n === i || Te || n === a || n === c || n === h || ae || n === b || Ge || Pe || qe || typeof n == "object" && n !== null && (n.$$typeof === w || n.$$typeof === g || n.$$typeof === l || n.$$typeof === p || n.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === ie || n.getModuleId !== void 0));
    }
    function Je(n, s, u) {
      var d = n.displayName;
      if (d)
        return d;
      var _ = s.displayName || s.name || "";
      return _ !== "" ? u + "(" + _ + ")" : u;
    }
    function ye(n) {
      return n.displayName || "Context";
    }
    function U(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            var s = n;
            return ye(s) + ".Consumer";
          case l:
            var u = n;
            return ye(u._context) + ".Provider";
          case f:
            return Je(n, n.render, "ForwardRef");
          case g:
            var d = n.displayName || null;
            return d !== null ? d : U(n.type) || "Memo";
          case w: {
            var _ = n, x = _._payload, m = _._init;
            try {
              return U(m(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, N = 0, Ie, xe, ve, z, ke, Ce, ue;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function fe() {
      {
        if (N === 0) {
          Ie = console.log, xe = console.info, ve = console.warn, z = console.error, ke = console.group, Ce = console.groupCollapsed, ue = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        N++;
      }
    }
    function Qe() {
      {
        if (N--, N === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, n, {
              value: Ie
            }),
            info: P({}, n, {
              value: xe
            }),
            warn: P({}, n, {
              value: ve
            }),
            error: P({}, n, {
              value: z
            }),
            group: P({}, n, {
              value: ke
            }),
            groupCollapsed: P({}, n, {
              value: Ce
            }),
            groupEnd: P({}, n, {
              value: ue
            })
          });
        }
        N < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = I.ReactCurrentDispatcher, pe;
    function Q(n, s, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (_) {
            var d = _.stack.trim().match(/\n( *(at )?)/);
            pe = d && d[1] || "";
          }
        return `
` + pe + n;
      }
    }
    var he = !1, X;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      X = new Se();
    }
    function Z(n, s) {
      if (!n || he)
        return "";
      {
        var u = X.get(n);
        if (u !== void 0)
          return u;
      }
      var d;
      he = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = V.current, V.current = null, fe();
      try {
        if (s) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (Y) {
              d = Y;
            }
            Reflect.construct(n, [], m);
          } else {
            try {
              m.call();
            } catch (Y) {
              d = Y;
            }
            n.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Y) {
            d = Y;
          }
          n();
        }
      } catch (Y) {
        if (Y && d && typeof Y.stack == "string") {
          for (var v = Y.stack.split(`
`), T = d.stack.split(`
`), D = v.length - 1, O = T.length - 1; D >= 1 && O >= 0 && v[D] !== T[O]; )
            O--;
          for (; D >= 1 && O >= 0; D--, O--)
            if (v[D] !== T[O]) {
              if (D !== 1 || O !== 1)
                do
                  if (D--, O--, O < 0 || v[D] !== T[O]) {
                    var A = `
` + v[D].replace(" at new ", " at ");
                    return n.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", n.displayName)), typeof n == "function" && X.set(n, A), A;
                  }
                while (D >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = x, Qe(), Error.prepareStackTrace = _;
      }
      var J = n ? n.displayName || n.name : "", bt = J ? Q(J) : "";
      return typeof n == "function" && X.set(n, bt), bt;
    }
    function Ze(n, s, u) {
      return Z(n, !1);
    }
    function et(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(n, s, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Z(n, et(n));
      if (typeof n == "string")
        return Q(n);
      switch (n) {
        case c:
          return Q("Suspense");
        case h:
          return Q("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            return Ze(n.render);
          case g:
            return ee(n.type, s, u);
          case w: {
            var d = n, _ = d._payload, x = d._init;
            try {
              return ee(x(_), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, re = {}, me = I.ReactDebugCurrentFrame;
    function G(n) {
      if (n) {
        var s = n._owner, u = ee(n.type, n._source, s ? s.type : null);
        me.setExtraStackFrame(u);
      } else
        me.setExtraStackFrame(null);
    }
    function Oe(n, s, u, d, _) {
      {
        var x = Function.call.bind(te);
        for (var m in n)
          if (x(n, m)) {
            var v = void 0;
            try {
              if (typeof n[m] != "function") {
                var T = Error((d || "React class") + ": " + u + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              v = n[m](s, m, d, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              v = D;
            }
            v && !(v instanceof Error) && (G(_), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", u, m, typeof v), G(null)), v instanceof Error && !(v.message in re) && (re[v.message] = !0, G(_), j("Failed %s type: %s", u, v.message), G(null));
          }
      }
    }
    var ft = Array.isArray;
    function be(n) {
      return ft(n);
    }
    function pt(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function y(n) {
      try {
        return S(n), !1;
      } catch {
        return !0;
      }
    }
    function S(n) {
      return "" + n;
    }
    function F(n) {
      if (y(n))
        return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(n)), S(n);
    }
    var k = I.ReactCurrentOwner, K = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, se, ne, ce;
    ce = {};
    function Fe(n) {
      if (te.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Ae(n) {
      if (te.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Re(n, s) {
      if (typeof n.ref == "string" && k.current && s && k.current.stateNode !== s) {
        var u = U(k.current.type);
        ce[u] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(k.current.type), n.ref), ce[u] = !0);
      }
    }
    function Me(n, s) {
      {
        var u = function() {
          se || (se = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Ue(n, s) {
      {
        var u = function() {
          ne || (ne = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Ne = function(n, s, u, d, _, x, m) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: u,
        props: m,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function Le(n, s, u, d, _) {
      {
        var x, m = {}, v = null, T = null;
        u !== void 0 && (F(u), v = "" + u), Ae(s) && (F(s.key), v = "" + s.key), Fe(s) && (T = s.ref, Re(s, _));
        for (x in s)
          te.call(s, x) && !K.hasOwnProperty(x) && (m[x] = s[x]);
        if (n && n.defaultProps) {
          var D = n.defaultProps;
          for (x in D)
            m[x] === void 0 && (m[x] = D[x]);
        }
        if (v || T) {
          var O = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          v && Me(m, O), T && Ue(m, O);
        }
        return Ne(n, v, T, _, d, k.current, m);
      }
    }
    var we = I.ReactCurrentOwner, ht = I.ReactDebugCurrentFrame;
    function q(n) {
      if (n) {
        var s = n._owner, u = ee(n.type, n._source, s ? s.type : null);
        ht.setExtraStackFrame(u);
      } else
        ht.setExtraStackFrame(null);
    }
    var Be;
    Be = !1;
    function He(n) {
      return typeof n == "object" && n !== null && n.$$typeof === t;
    }
    function dt() {
      {
        if (we.current) {
          var n = U(we.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Jt(n) {
      return "";
    }
    var gt = {};
    function Qt(n) {
      {
        var s = dt();
        if (!s) {
          var u = typeof n == "string" ? n : n.displayName || n.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function yt(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var u = Qt(s);
        if (gt[u])
          return;
        gt[u] = !0;
        var d = "";
        n && n._owner && n._owner !== we.current && (d = " It was passed a child from " + U(n._owner.type) + "."), q(n), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, d), q(null);
      }
    }
    function vt(n, s) {
      {
        if (typeof n != "object")
          return;
        if (be(n))
          for (var u = 0; u < n.length; u++) {
            var d = n[u];
            He(d) && yt(d, s);
          }
        else if (He(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var _ = B(n);
          if (typeof _ == "function" && _ !== n.entries)
            for (var x = _.call(n), m; !(m = x.next()).done; )
              He(m.value) && yt(m.value, s);
        }
      }
    }
    function Zt(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === g))
          u = s.propTypes;
        else
          return;
        if (u) {
          var d = U(s);
          Oe(u, n.props, "prop", d, n);
        } else if (s.PropTypes !== void 0 && !Be) {
          Be = !0;
          var _ = U(s);
          j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function er(n) {
      {
        for (var s = Object.keys(n.props), u = 0; u < s.length; u++) {
          var d = s[u];
          if (d !== "children" && d !== "key") {
            q(n), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), q(null);
            break;
          }
        }
        n.ref !== null && (q(n), j("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
      }
    }
    function mt(n, s, u, d, _, x) {
      {
        var m = ge(n);
        if (!m) {
          var v = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Jt();
          T ? v += T : v += dt();
          var D;
          n === null ? D = "null" : be(n) ? D = "array" : n !== void 0 && n.$$typeof === t ? (D = "<" + (U(n.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : D = typeof n, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, v);
        }
        var O = Le(n, s, u, _, x);
        if (O == null)
          return O;
        if (m) {
          var A = s.children;
          if (A !== void 0)
            if (d)
              if (be(A)) {
                for (var J = 0; J < A.length; J++)
                  vt(A[J], n);
                Object.freeze && Object.freeze(A);
              } else
                j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vt(A, n);
        }
        return n === o ? er(O) : Zt(O), O;
      }
    }
    function tr(n, s, u) {
      return mt(n, s, u, !0);
    }
    function rr(n, s, u) {
      return mt(n, s, u, !1);
    }
    var nr = rr, or = tr;
    Pt.Fragment = o, Pt.jsx = nr, Pt.jsxs = or;
  }()), Pt;
}
process.env.NODE_ENV === "production" ? gr.exports = oo() : gr.exports = ao();
var _e = gr.exports;
function at(e, t, r, o) {
  function a(i) {
    return i instanceof r ? i : new r(function(l) {
      l(i);
    });
  }
  return new (r || (r = Promise))(function(i, l) {
    function p(h) {
      try {
        c(o.next(h));
      } catch (g) {
        l(g);
      }
    }
    function f(h) {
      try {
        c(o.throw(h));
      } catch (g) {
        l(g);
      }
    }
    function c(h) {
      h.done ? i(h.value) : a(h.value).then(p, f);
    }
    c((o = o.apply(e, [])).next());
  });
}
function it(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, o, a, i, l = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return l.next = p(0), l.throw = p(1), l.return = p(2), typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function p(c) {
    return function(h) {
      return f([c, h]);
    };
  }
  function f(c) {
    if (o) throw new TypeError("Generator is already executing.");
    for (; l && (l = 0, c[0] && (r = 0)), r; ) try {
      if (o = 1, a && (i = c[0] & 2 ? a.return : c[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, c[1])).done) return i;
      switch (a = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
        case 0:
        case 1:
          i = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, a = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = c;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(c);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (h) {
      c = [6, h], a = 0;
    } finally {
      o = i = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Br(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var o = r.call(e), a, i = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = o.next()).done; ) i.push(a.value);
  } catch (p) {
    l = { error: p };
  } finally {
    try {
      a && !a.done && (r = o.return) && r.call(o);
    } finally {
      if (l) throw l.error;
    }
  }
  return i;
}
function Hr(e, t, r) {
  if (arguments.length === 2) for (var o = 0, a = t.length, i; o < a; o++)
    (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var io = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Et(e, t) {
  var r = so(e);
  if (typeof r.path != "string") {
    var o = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function so(e) {
  var t = e.name, r = t && t.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var o = t.split(".").pop().toLowerCase(), a = io.get(o);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var co = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function lo(e) {
  return at(this, void 0, void 0, function() {
    return it(this, function(t) {
      return At(e) && uo(e.dataTransfer) ? [2, go(e.dataTransfer, e.type)] : fo(e) ? [2, po(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, ho(e)] : [2, []];
    });
  });
}
function uo(e) {
  return At(e);
}
function fo(e) {
  return At(e) && At(e.target);
}
function At(e) {
  return typeof e == "object" && e !== null;
}
function po(e) {
  return yr(e.target.files).map(function(t) {
    return Et(t);
  });
}
function ho(e) {
  return at(this, void 0, void 0, function() {
    var t;
    return it(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(o) {
            return o.getFile();
          }))];
        case 1:
          return t = r.sent(), [2, t.map(function(o) {
            return Et(o);
          })];
      }
    });
  });
}
function go(e, t) {
  return at(this, void 0, void 0, function() {
    var r, o;
    return it(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (r = yr(e.items).filter(function(i) {
            return i.kind === "file";
          }), t !== "drop" ? [2, r] : [4, Promise.all(r.map(yo))]) : [3, 2];
        case 1:
          return o = a.sent(), [2, zr(pn(o))];
        case 2:
          return [2, zr(yr(e.files).map(function(i) {
            return Et(i);
          }))];
      }
    });
  });
}
function zr(e) {
  return e.filter(function(t) {
    return co.indexOf(t.name) === -1;
  });
}
function yr(e) {
  if (e === null)
    return [];
  for (var t = [], r = 0; r < e.length; r++) {
    var o = e[r];
    t.push(o);
  }
  return t;
}
function yo(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Yr(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? hn(t) : Yr(e);
}
function pn(e) {
  return e.reduce(function(t, r) {
    return Hr(Hr([], Br(t), !1), Br(Array.isArray(r) ? pn(r) : [r]), !1);
  }, []);
}
function Yr(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var r = Et(t);
  return Promise.resolve(r);
}
function vo(e) {
  return at(this, void 0, void 0, function() {
    return it(this, function(t) {
      return [2, e.isDirectory ? hn(e) : mo(e)];
    });
  });
}
function hn(e) {
  var t = e.createReader();
  return new Promise(function(r, o) {
    var a = [];
    function i() {
      var l = this;
      t.readEntries(function(p) {
        return at(l, void 0, void 0, function() {
          var f, c, h;
          return it(this, function(g) {
            switch (g.label) {
              case 0:
                if (p.length) return [3, 5];
                g.label = 1;
              case 1:
                return g.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return f = g.sent(), r(f), [3, 4];
              case 3:
                return c = g.sent(), o(c), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                h = Promise.all(p.map(vo)), a.push(h), i(), g.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(p) {
        o(p);
      });
    }
    i();
  });
}
function mo(e) {
  return at(this, void 0, void 0, function() {
    return it(this, function(t) {
      return [2, new Promise(function(r, o) {
        e.file(function(a) {
          var i = Et(a, e.fullPath);
          r(i);
        }, function(a) {
          o(a);
        });
      })];
    });
  });
}
var bo = function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), o = e.name || "", a = (e.type || "").toLowerCase(), i = a.replace(/\/.*$/, "");
    return r.some(function(l) {
      var p = l.trim().toLowerCase();
      return p.charAt(0) === "." ? o.toLowerCase().endsWith(p) : p.endsWith("/*") ? i === p.replace(/\/.*$/, "") : a === p;
    });
  }
  return !0;
};
function Kr(e) {
  return xo(e) || _o(e) || gn(e) || wo();
}
function wo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _o(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function xo(e) {
  if (Array.isArray(e)) return vr(e);
}
function Wr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wr(Object(r), !0).forEach(function(o) {
      dn(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wr(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function dn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dt(e, t) {
  return So(e) || Do(e, t) || gn(e, t) || Co();
}
function Co() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gn(e, t) {
  if (e) {
    if (typeof e == "string") return vr(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vr(e, t);
  }
}
function vr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = new Array(t); r < t; r++)
    o[r] = e[r];
  return o;
}
function Do(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var o = [], a = !0, i = !1, l, p;
    try {
      for (r = r.call(e); !(a = (l = r.next()).done) && (o.push(l.value), !(t && o.length === t)); a = !0)
        ;
    } catch (f) {
      i = !0, p = f;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw p;
      }
    }
    return o;
  }
}
function So(e) {
  if (Array.isArray(e)) return e;
}
var Oo = "file-invalid-type", Ro = "file-too-large", Eo = "file-too-small", jo = "too-many-files", $o = function(e) {
  e = Array.isArray(e) && e.length === 1 ? e[0] : e;
  var t = Array.isArray(e) ? "one of ".concat(e.join(", ")) : e;
  return {
    code: Oo,
    message: "File type must be ".concat(t)
  };
}, Xr = function(e) {
  return {
    code: Ro,
    message: "File is larger than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, Gr = function(e) {
  return {
    code: Eo,
    message: "File is smaller than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, Po = {
  code: jo,
  message: "Too many files"
};
function yn(e, t) {
  var r = e.type === "application/x-moz-file" || bo(e, t);
  return [r, r ? null : $o(t)];
}
function vn(e, t, r) {
  if (ze(e.size))
    if (ze(t) && ze(r)) {
      if (e.size > r) return [!1, Xr(r)];
      if (e.size < t) return [!1, Gr(t)];
    } else {
      if (ze(t) && e.size < t) return [!1, Gr(t)];
      if (ze(r) && e.size > r) return [!1, Xr(r)];
    }
  return [!0, null];
}
function ze(e) {
  return e != null;
}
function To(e) {
  var t = e.files, r = e.accept, o = e.minSize, a = e.maxSize, i = e.multiple, l = e.maxFiles, p = e.validator;
  return !i && t.length > 1 || i && l >= 1 && t.length > l ? !1 : t.every(function(f) {
    var c = yn(f, r), h = Dt(c, 1), g = h[0], w = vn(f, o, a), b = Dt(w, 1), R = b[0], M = p ? p(f) : null;
    return g && R && !M;
  });
}
function Mt(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Tt(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function qr(e) {
  e.preventDefault();
}
function Io(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function ko(e) {
  return e.indexOf("Edge/") !== -1;
}
function Fo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return Io(e) || ko(e);
}
function de() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(o) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
      i[l - 1] = arguments[l];
    return t.some(function(p) {
      return !Mt(o) && p && p.apply(void 0, [o].concat(i)), Mt(o);
    });
  };
}
function Ao() {
  return "showOpenFilePicker" in window;
}
function Mo(e) {
  if (ze(e)) {
    var t = Object.entries(e).filter(function(r) {
      var o = Dt(r, 2), a = o[0], i = o[1], l = !0;
      return mn(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(i) || !i.every(bn)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(r, o) {
      var a = Dt(o, 2), i = a[0], l = a[1];
      return Vr(Vr({}, r), {}, dn({}, i, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function Uo(e) {
  if (ze(e))
    return Object.entries(e).reduce(function(t, r) {
      var o = Dt(r, 2), a = o[0], i = o[1];
      return [].concat(Kr(t), [a], Kr(i));
    }, []).filter(function(t) {
      return mn(t) || bn(t);
    }).join(",");
}
function No(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function Lo(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function mn(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function bn(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Bo = ["children"], Ho = ["open"], zo = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Yo = ["refKey", "onChange", "onClick"];
function Ko(e) {
  return Xo(e) || Vo(e) || wn(e) || Wo();
}
function Wo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vo(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Xo(e) {
  if (Array.isArray(e)) return mr(e);
}
function ir(e, t) {
  return Jo(e) || qo(e, t) || wn(e, t) || Go();
}
function Go() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wn(e, t) {
  if (e) {
    if (typeof e == "string") return mr(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mr(e, t);
  }
}
function mr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, o = new Array(t); r < t; r++)
    o[r] = e[r];
  return o;
}
function qo(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var o = [], a = !0, i = !1, l, p;
    try {
      for (r = r.call(e); !(a = (l = r.next()).done) && (o.push(l.value), !(t && o.length === t)); a = !0)
        ;
    } catch (f) {
      i = !0, p = f;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw p;
      }
    }
    return o;
  }
}
function Jo(e) {
  if (Array.isArray(e)) return e;
}
function Jr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function L(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jr(Object(r), !0).forEach(function(o) {
      br(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jr(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function br(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ut(e, t) {
  if (e == null) return {};
  var r = Qo(e, t), o, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      o = i[a], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (r[o] = e[o]);
  }
  return r;
}
function Qo(e, t) {
  if (e == null) return {};
  var r = {}, o = Object.keys(e), a, i;
  for (i = 0; i < o.length; i++)
    a = o[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var zt = /* @__PURE__ */ Gn(function(e, t) {
  var r = e.children, o = Ut(e, Bo), a = Zo(o), i = a.open, l = Ut(a, Ho);
  return qn(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ $.createElement(Jn, null, r(L(L({}, l), {}, {
    open: i
  })));
});
zt.displayName = "Dropzone";
var _n = {
  disabled: !1,
  getFilesFromEvent: lo,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
zt.defaultProps = _n;
zt.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: C.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: C.objectOf(C.arrayOf(C.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: C.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: C.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: C.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: C.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: C.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: C.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: C.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: C.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: C.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: C.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: C.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: C.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: C.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: C.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: C.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: C.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: C.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: C.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: C.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: C.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: C.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: C.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: C.func
};
var wr = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Zo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = L(L({}, _n), e), r = t.accept, o = t.disabled, a = t.getFilesFromEvent, i = t.maxSize, l = t.minSize, p = t.multiple, f = t.maxFiles, c = t.onDragEnter, h = t.onDragLeave, g = t.onDragOver, w = t.onDrop, b = t.onDropAccepted, R = t.onDropRejected, M = t.onFileDialogCancel, B = t.onFileDialogOpen, I = t.useFsAccessApi, j = t.autoFocus, $e = t.preventDropOnDocument, Ge = t.noClick, Pe = t.noKeyboard, qe = t.noDrag, ae = t.noDragEventsBubbling, Te = t.onError, ie = t.validator, ge = tt(function() {
    return Uo(r);
  }, [r]), Je = tt(function() {
    return Mo(r);
  }, [r]), ye = tt(function() {
    return typeof B == "function" ? B : Qr;
  }, [B]), U = tt(function() {
    return typeof M == "function" ? M : Qr;
  }, [M]), P = $t(null), N = $t(null), Ie = Qn(ea, wr), xe = ir(Ie, 2), ve = xe[0], z = xe[1], ke = ve.isFocused, Ce = ve.isFileDialogActive, ue = $t(typeof window < "u" && window.isSecureContext && I && Ao()), De = function() {
    !ue.current && Ce && setTimeout(function() {
      if (N.current) {
        var y = N.current.files;
        y.length || (z({
          type: "closeDialog"
        }), U());
      }
    }, 300);
  };
  ar(function() {
    return window.addEventListener("focus", De, !1), function() {
      window.removeEventListener("focus", De, !1);
    };
  }, [N, Ce, U, ue]);
  var fe = $t([]), Qe = function(y) {
    P.current && P.current.contains(y.target) || (y.preventDefault(), fe.current = []);
  };
  ar(function() {
    return $e && (document.addEventListener("dragover", qr, !1), document.addEventListener("drop", Qe, !1)), function() {
      $e && (document.removeEventListener("dragover", qr), document.removeEventListener("drop", Qe));
    };
  }, [P, $e]), ar(function() {
    return !o && j && P.current && P.current.focus(), function() {
    };
  }, [P, j, o]);
  var V = oe(function(y) {
    Te ? Te(y) : console.error(y);
  }, [Te]), pe = oe(function(y) {
    y.preventDefault(), y.persist(), Oe(y), fe.current = [].concat(Ko(fe.current), [y.target]), Tt(y) && Promise.resolve(a(y)).then(function(S) {
      if (!(Mt(y) && !ae)) {
        var F = S.length, k = F > 0 && To({
          files: S,
          accept: ge,
          minSize: l,
          maxSize: i,
          multiple: p,
          maxFiles: f,
          validator: ie
        }), K = F > 0 && !k;
        z({
          isDragAccept: k,
          isDragReject: K,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), c && c(y);
      }
    }).catch(function(S) {
      return V(S);
    });
  }, [a, c, V, ae, ge, l, i, p, f, ie]), Q = oe(function(y) {
    y.preventDefault(), y.persist(), Oe(y);
    var S = Tt(y);
    if (S && y.dataTransfer)
      try {
        y.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return S && g && g(y), !1;
  }, [g, ae]), he = oe(function(y) {
    y.preventDefault(), y.persist(), Oe(y);
    var S = fe.current.filter(function(k) {
      return P.current && P.current.contains(k);
    }), F = S.indexOf(y.target);
    F !== -1 && S.splice(F, 1), fe.current = S, !(S.length > 0) && (z({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Tt(y) && h && h(y));
  }, [P, h, ae]), X = oe(function(y, S) {
    var F = [], k = [];
    y.forEach(function(K) {
      var se = yn(K, ge), ne = ir(se, 2), ce = ne[0], Fe = ne[1], Ae = vn(K, l, i), Re = ir(Ae, 2), Me = Re[0], Ue = Re[1], Ne = ie ? ie(K) : null;
      if (ce && Me && !Ne)
        F.push(K);
      else {
        var Le = [Fe, Ue];
        Ne && (Le = Le.concat(Ne)), k.push({
          file: K,
          errors: Le.filter(function(we) {
            return we;
          })
        });
      }
    }), (!p && F.length > 1 || p && f >= 1 && F.length > f) && (F.forEach(function(K) {
      k.push({
        file: K,
        errors: [Po]
      });
    }), F.splice(0)), z({
      acceptedFiles: F,
      fileRejections: k,
      type: "setFiles"
    }), w && w(F, k, S), k.length > 0 && R && R(k, S), F.length > 0 && b && b(F, S);
  }, [z, p, ge, l, i, f, w, b, R, ie]), Se = oe(function(y) {
    y.preventDefault(), y.persist(), Oe(y), fe.current = [], Tt(y) && Promise.resolve(a(y)).then(function(S) {
      Mt(y) && !ae || X(S, y);
    }).catch(function(S) {
      return V(S);
    }), z({
      type: "reset"
    });
  }, [a, X, V, ae]), Z = oe(function() {
    if (ue.current) {
      z({
        type: "openDialog"
      }), ye();
      var y = {
        multiple: p,
        types: Je
      };
      window.showOpenFilePicker(y).then(function(S) {
        return a(S);
      }).then(function(S) {
        X(S, null), z({
          type: "closeDialog"
        });
      }).catch(function(S) {
        No(S) ? (U(S), z({
          type: "closeDialog"
        })) : Lo(S) ? (ue.current = !1, N.current ? (N.current.value = null, N.current.click()) : V(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : V(S);
      });
      return;
    }
    N.current && (z({
      type: "openDialog"
    }), ye(), N.current.value = null, N.current.click());
  }, [z, ye, U, I, X, V, Je, p]), Ze = oe(function(y) {
    !P.current || !P.current.isEqualNode(y.target) || (y.key === " " || y.key === "Enter" || y.keyCode === 32 || y.keyCode === 13) && (y.preventDefault(), Z());
  }, [P, Z]), et = oe(function() {
    z({
      type: "focus"
    });
  }, []), ee = oe(function() {
    z({
      type: "blur"
    });
  }, []), te = oe(function() {
    Ge || (Fo() ? setTimeout(Z, 0) : Z());
  }, [Ge, Z]), re = function(y) {
    return o ? null : y;
  }, me = function(y) {
    return Pe ? null : re(y);
  }, G = function(y) {
    return qe ? null : re(y);
  }, Oe = function(y) {
    ae && y.stopPropagation();
  }, ft = tt(function() {
    return function() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, S = y.refKey, F = S === void 0 ? "ref" : S, k = y.role, K = y.onKeyDown, se = y.onFocus, ne = y.onBlur, ce = y.onClick, Fe = y.onDragEnter, Ae = y.onDragOver, Re = y.onDragLeave, Me = y.onDrop, Ue = Ut(y, zo);
      return L(L(br({
        onKeyDown: me(de(K, Ze)),
        onFocus: me(de(se, et)),
        onBlur: me(de(ne, ee)),
        onClick: re(de(ce, te)),
        onDragEnter: G(de(Fe, pe)),
        onDragOver: G(de(Ae, Q)),
        onDragLeave: G(de(Re, he)),
        onDrop: G(de(Me, Se)),
        role: typeof k == "string" && k !== "" ? k : "presentation"
      }, F, P), !o && !Pe ? {
        tabIndex: 0
      } : {}), Ue);
    };
  }, [P, Ze, et, ee, te, pe, Q, he, Se, Pe, qe, o]), be = oe(function(y) {
    y.stopPropagation();
  }, []), pt = tt(function() {
    return function() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, S = y.refKey, F = S === void 0 ? "ref" : S, k = y.onChange, K = y.onClick, se = Ut(y, Yo), ne = br({
        accept: ge,
        multiple: p,
        type: "file",
        style: {
          display: "none"
        },
        onChange: re(de(k, Se)),
        onClick: re(de(K, be)),
        tabIndex: -1
      }, F, N);
      return L(L({}, ne), se);
    };
  }, [N, r, p, Se, o]);
  return L(L({}, ve), {}, {
    isFocused: ke && !o,
    getRootProps: ft,
    getInputProps: pt,
    rootRef: P,
    inputRef: N,
    open: re(Z)
  });
}
function ea(e, t) {
  switch (t.type) {
    case "focus":
      return L(L({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return L(L({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return L(L({}, wr), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return L(L({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return L(L({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return L(L({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return L({}, wr);
    default:
      return e;
  }
}
function Qr() {
}
const ta = "M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z", ra = ({ width: e = 50, height: t = 43, style: r = {} }) => /* @__PURE__ */ _e.jsx("svg", { className: "uploader-icon", xmlns: "http://www.w3.org/2000/svg", style: r, width: e, height: t, viewBox: "0 0 50 43", children: /* @__PURE__ */ _e.jsx("path", { d: ta }) }), na = ({ isDragActive: e, isDragAccept: t, isDragReject: r }) => {
  const o = ["uploader-default-placeholder"];
  return t ? o.push("drag-accept") : r ? o.push("drag-reject") : e && o.push("drag-active"), /* @__PURE__ */ _e.jsxs("div", { className: o.join(" "), children: [
    /* @__PURE__ */ _e.jsx(ra, {}),
    /* @__PURE__ */ _e.jsx("div", { className: "placeholder-text", children: "Try dropping some files here, or click to select files to upload." })
  ] });
};
class _r extends Ht {
  constructor() {
    super(...arguments), dr(this, "onDrop", (t, r) => {
      const { onChange: o } = this.props;
      o(t, r);
    });
  }
  render() {
    const { name: t, disabled: r, multiple: o, accept: a, placeholder: i } = this.props;
    return /* @__PURE__ */ _e.jsx(zt, { onDrop: this.onDrop, multiple: o, accept: a, disabled: r, children: ({ getRootProps: l, getInputProps: p, isDragActive: f, isDragAccept: c, isDragReject: h }) => /* @__PURE__ */ _e.jsxs(
      "div",
      {
        ...l(),
        children: [
          /* @__PURE__ */ _e.jsx("input", { name: t, ...p() }),
          /* @__PURE__ */ _e.jsx(i, { isDragActive: f, isDragAccept: c, isDragReject: h })
        ]
      }
    ) });
  }
}
dr(_r, "propTypes", {
  name: C.string,
  disabled: C.bool,
  multiple: C.bool,
  onChange: C.func.isRequired,
  placeholder: C.oneOfType([
    C.string,
    C.func
  ]),
  accept: C.objectOf(C.arrayOf(C.string))
}), dr(_r, "defaultProps", {
  multiple: !1,
  disabled: !1,
  placeholder: na
});
const Dr = ({ onFileSelected: e }) => /* @__PURE__ */ E.jsx(
  _r,
  {
    multiple: !1,
    accept: {
      "image/*": []
    },
    onChange: e,
    placeholder: () => /* @__PURE__ */ E.jsx("div", { style: { width: "100%", height: 40, outline: "dashed black", textAlign: "center", cursor: "pointer" }, children: " Give image " })
  }
);
Dr.propTypes = {
  onFileSelected: C.func
};
var W = [];
for (var sr = 0; sr < 256; ++sr)
  W.push((sr + 256).toString(16).slice(1));
function oa(e, t = 0) {
  return (W[e[t + 0]] + W[e[t + 1]] + W[e[t + 2]] + W[e[t + 3]] + "-" + W[e[t + 4]] + W[e[t + 5]] + "-" + W[e[t + 6]] + W[e[t + 7]] + "-" + W[e[t + 8]] + W[e[t + 9]] + "-" + W[e[t + 10]] + W[e[t + 11]] + W[e[t + 12]] + W[e[t + 13]] + W[e[t + 14]] + W[e[t + 15]]).toLowerCase();
}
var It, aa = new Uint8Array(16);
function ia() {
  if (!It && (It = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !It))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return It(aa);
}
var sa = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Zr = {
  randomUUID: sa
};
function ca(e, t, r) {
  if (Zr.randomUUID && !t && !e)
    return Zr.randomUUID();
  e = e || {};
  var o = e.random || (e.rng || ia)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, oa(o);
}
var la = 200, Sr = "__lodash_hash_undefined__", ua = 1 / 0, xn = 9007199254740991, fa = "[object Arguments]", pa = "[object Function]", ha = "[object GeneratorFunction]", da = "[object Symbol]", ga = /[\\^$.*+?()[\]{}|]/g, ya = /^\[object .+?Constructor\]$/, va = /^(?:0|[1-9]\d*)$/, ma = typeof window == "object" && window && window.Object === Object && window, ba = typeof self == "object" && self && self.Object === Object && self, Or = ma || ba || Function("return this")();
function wa(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function _a(e, t) {
  var r = e ? e.length : 0;
  return !!r && Da(e, t, 0) > -1;
}
function xa(e, t) {
  for (var r = -1, o = e ? e.length : 0, a = Array(o); ++r < o; )
    a[r] = t(e[r], r, e);
  return a;
}
function Rr(e, t) {
  for (var r = -1, o = t.length, a = e.length; ++r < o; )
    e[a + r] = t[r];
  return e;
}
function Ca(e, t, r, o) {
  for (var a = e.length, i = r + -1; ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function Da(e, t, r) {
  if (t !== t)
    return Ca(e, Sa, r);
  for (var o = r - 1, a = e.length; ++o < a; )
    if (e[o] === t)
      return o;
  return -1;
}
function Sa(e) {
  return e !== e;
}
function Oa(e, t) {
  for (var r = -1, o = Array(e); ++r < e; )
    o[r] = t(r);
  return o;
}
function Ra(e, t) {
  return e.has(t);
}
function Ea(e, t) {
  return e == null ? void 0 : e[t];
}
function ja(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
function Cn(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var $a = Array.prototype, Pa = Function.prototype, Yt = Object.prototype, cr = Or["__core-js_shared__"], en = function() {
  var e = /[^.]+$/.exec(cr && cr.keys && cr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), Dn = Pa.toString, jt = Yt.hasOwnProperty, Er = Yt.toString, Ta = RegExp(
  "^" + Dn.call(jt).replace(ga, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), tn = Or.Symbol, Ia = Cn(Object.getPrototypeOf, Object), ka = Yt.propertyIsEnumerable, Fa = $a.splice, rn = tn ? tn.isConcatSpreadable : void 0, xr = Object.getOwnPropertySymbols, nn = Math.max, Aa = Sn(Or, "Map"), St = Sn(Object, "create");
function Ye(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function Ma() {
  this.__data__ = St ? St(null) : {};
}
function Ua(e) {
  return this.has(e) && delete this.__data__[e];
}
function Na(e) {
  var t = this.__data__;
  if (St) {
    var r = t[e];
    return r === Sr ? void 0 : r;
  }
  return jt.call(t, e) ? t[e] : void 0;
}
function La(e) {
  var t = this.__data__;
  return St ? t[e] !== void 0 : jt.call(t, e);
}
function Ba(e, t) {
  var r = this.__data__;
  return r[e] = St && t === void 0 ? Sr : t, this;
}
Ye.prototype.clear = Ma;
Ye.prototype.delete = Ua;
Ye.prototype.get = Na;
Ye.prototype.has = La;
Ye.prototype.set = Ba;
function st(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function Ha() {
  this.__data__ = [];
}
function za(e) {
  var t = this.__data__, r = Kt(t, e);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : Fa.call(t, r, 1), !0;
}
function Ya(e) {
  var t = this.__data__, r = Kt(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Ka(e) {
  return Kt(this.__data__, e) > -1;
}
function Wa(e, t) {
  var r = this.__data__, o = Kt(r, e);
  return o < 0 ? r.push([e, t]) : r[o][1] = t, this;
}
st.prototype.clear = Ha;
st.prototype.delete = za;
st.prototype.get = Ya;
st.prototype.has = Ka;
st.prototype.set = Wa;
function ct(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function Va() {
  this.__data__ = {
    hash: new Ye(),
    map: new (Aa || st)(),
    string: new Ye()
  };
}
function Xa(e) {
  return Wt(this, e).delete(e);
}
function Ga(e) {
  return Wt(this, e).get(e);
}
function qa(e) {
  return Wt(this, e).has(e);
}
function Ja(e, t) {
  return Wt(this, e).set(e, t), this;
}
ct.prototype.clear = Va;
ct.prototype.delete = Xa;
ct.prototype.get = Ga;
ct.prototype.has = qa;
ct.prototype.set = Ja;
function Nt(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.__data__ = new ct(); ++t < r; )
    this.add(e[t]);
}
function Qa(e) {
  return this.__data__.set(e, Sr), this;
}
function Za(e) {
  return this.__data__.has(e);
}
Nt.prototype.add = Nt.prototype.push = Qa;
Nt.prototype.has = Za;
function ei(e, t) {
  var r = jr(e) || On(e) ? Oa(e.length, String) : [], o = r.length, a = !!o;
  for (var i in e)
    a && (i == "length" || hi(i, o)) || r.push(i);
  return r;
}
function Kt(e, t) {
  for (var r = e.length; r--; )
    if (wi(e[r][0], t))
      return r;
  return -1;
}
function ti(e, t, r, o) {
  var a = -1, i = _a, l = !0, p = e.length, f = [], c = t.length;
  if (!p)
    return f;
  t.length >= la && (i = Ra, l = !1, t = new Nt(t));
  e:
    for (; ++a < p; ) {
      var h = e[a], g = h;
      if (h = h !== 0 ? h : 0, l && g === g) {
        for (var w = c; w--; )
          if (t[w] === g)
            continue e;
        f.push(h);
      } else i(t, g, o) || f.push(h);
    }
  return f;
}
function ri(e, t, r, o, a) {
  var i = -1, l = e.length;
  for (r || (r = pi), a || (a = []); ++i < l; ) {
    var p = e[i];
    r(p) ? Rr(a, p) : a[a.length] = p;
  }
  return a;
}
function ni(e, t, r) {
  var o = t(e);
  return jr(e) ? o : Rr(o, r(e));
}
function oi(e) {
  if (!$r(e) || gi(e))
    return !1;
  var t = En(e) || ja(e) ? Ta : ya;
  return t.test(bi(e));
}
function ai(e) {
  if (!$r(e))
    return vi(e);
  var t = yi(e), r = [];
  for (var o in e)
    o == "constructor" && (t || !jt.call(e, o)) || r.push(o);
  return r;
}
function ii(e, t) {
  return e = Object(e), si(e, t, function(r, o) {
    return o in e;
  });
}
function si(e, t, r) {
  for (var o = -1, a = t.length, i = {}; ++o < a; ) {
    var l = t[o], p = e[l];
    r(p, l) && (i[l] = p);
  }
  return i;
}
function ci(e, t) {
  return t = nn(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, a = nn(r.length - t, 0), i = Array(a); ++o < a; )
      i[o] = r[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = r[o];
    return l[t] = i, wa(e, this, l);
  };
}
function li(e) {
  return ni(e, Di, fi);
}
function Wt(e, t) {
  var r = e.__data__;
  return di(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Sn(e, t) {
  var r = Ea(e, t);
  return oi(r) ? r : void 0;
}
var ui = xr ? Cn(xr, Object) : $n, fi = xr ? function(e) {
  for (var t = []; e; )
    Rr(t, ui(e)), e = Ia(e);
  return t;
} : $n;
function pi(e) {
  return jr(e) || On(e) || !!(rn && e && e[rn]);
}
function hi(e, t) {
  return t = t ?? xn, !!t && (typeof e == "number" || va.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function di(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function gi(e) {
  return !!en && en in e;
}
function yi(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Yt;
  return e === r;
}
function vi(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
function mi(e) {
  if (typeof e == "string" || Ci(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -ua ? "-0" : t;
}
function bi(e) {
  if (e != null) {
    try {
      return Dn.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function wi(e, t) {
  return e === t || e !== e && t !== t;
}
function On(e) {
  return _i(e) && jt.call(e, "callee") && (!ka.call(e, "callee") || Er.call(e) == fa);
}
var jr = Array.isArray;
function Rn(e) {
  return e != null && xi(e.length) && !En(e);
}
function _i(e) {
  return jn(e) && Rn(e);
}
function En(e) {
  var t = $r(e) ? Er.call(e) : "";
  return t == pa || t == ha;
}
function xi(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= xn;
}
function $r(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function jn(e) {
  return !!e && typeof e == "object";
}
function Ci(e) {
  return typeof e == "symbol" || jn(e) && Er.call(e) == da;
}
function Di(e) {
  return Rn(e) ? ei(e) : ai(e);
}
var Si = ci(function(e, t) {
  return e == null ? {} : (t = xa(ri(t), mi), ii(e, ti(li(e), t)));
});
function $n() {
  return [];
}
var Oi = Si;
const Ri = /* @__PURE__ */ Cr(Oi), Lt = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, rt = (e, t, r) => Math.min(Math.max(e, t), r), Ei = (...e) => e.filter((t) => t && typeof t == "string").join(" "), on = (e, t) => e === t || e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.unit === t.unit;
function nt(e, t, r) {
  return e.unit === "%" ? { ...Lt, ...e, unit: "%" } : {
    unit: "%",
    x: e.x ? e.x / t * 100 : 0,
    y: e.y ? e.y / r * 100 : 0,
    width: e.width ? e.width / t * 100 : 0,
    height: e.height ? e.height / r * 100 : 0
  };
}
function Ee(e, t, r) {
  return e.unit ? e.unit === "px" ? { ...Lt, ...e, unit: "px" } : {
    unit: "px",
    x: e.x ? e.x * t / 100 : 0,
    y: e.y ? e.y * r / 100 : 0,
    width: e.width ? e.width * t / 100 : 0,
    height: e.height ? e.height * r / 100 : 0
  } : { ...Lt, ...e, unit: "px" };
}
function an(e, t, r, o, a, i = 0, l = 0, p = o, f = a) {
  const c = { ...e };
  let h = Math.min(i, o), g = Math.min(l, a), w = Math.min(p, o), b = Math.min(f, a);
  t && (t > 1 ? (h = l ? l * t : h, g = h / t, w = p * t) : (g = i ? i / t : g, h = g * t, b = f / t)), c.y < 0 && (c.height = Math.max(c.height + c.y, g), c.y = 0), c.x < 0 && (c.width = Math.max(c.width + c.x, h), c.x = 0);
  const R = o - (c.x + c.width);
  R < 0 && (c.x = Math.min(c.x, o - h), c.width += R);
  const M = a - (c.y + c.height);
  if (M < 0 && (c.y = Math.min(c.y, a - g), c.height += M), c.width < h && ((r === "sw" || r == "nw") && (c.x -= h - c.width), c.width = h), c.height < g && ((r === "nw" || r == "ne") && (c.y -= g - c.height), c.height = g), c.width > w && ((r === "sw" || r == "nw") && (c.x -= w - c.width), c.width = w), c.height > b && ((r === "nw" || r == "ne") && (c.y -= b - c.height), c.height = b), t) {
    const B = c.width / c.height;
    if (B < t) {
      const I = Math.max(c.width / t, g);
      (r === "nw" || r == "ne") && (c.y -= I - c.height), c.height = I;
    } else if (B > t) {
      const I = Math.max(c.height * t, h);
      (r === "sw" || r == "nw") && (c.x -= I - c.width), c.width = I;
    }
  }
  return c;
}
function ji(e, t, r, o) {
  const a = { ...e };
  return t === "ArrowLeft" ? o === "nw" ? (a.x -= r, a.y -= r, a.width += r, a.height += r) : o === "w" ? (a.x -= r, a.width += r) : o === "sw" ? (a.x -= r, a.width += r, a.height += r) : o === "ne" ? (a.y += r, a.width -= r, a.height -= r) : o === "e" ? a.width -= r : o === "se" && (a.width -= r, a.height -= r) : t === "ArrowRight" && (o === "nw" ? (a.x += r, a.y += r, a.width -= r, a.height -= r) : o === "w" ? (a.x += r, a.width -= r) : o === "sw" ? (a.x += r, a.width -= r, a.height -= r) : o === "ne" ? (a.y -= r, a.width += r, a.height += r) : o === "e" ? a.width += r : o === "se" && (a.width += r, a.height += r)), t === "ArrowUp" ? o === "nw" ? (a.x -= r, a.y -= r, a.width += r, a.height += r) : o === "n" ? (a.y -= r, a.height += r) : o === "ne" ? (a.y -= r, a.width += r, a.height += r) : o === "sw" ? (a.x += r, a.width -= r, a.height -= r) : o === "s" ? a.height -= r : o === "se" && (a.width -= r, a.height -= r) : t === "ArrowDown" && (o === "nw" ? (a.x += r, a.y += r, a.width -= r, a.height -= r) : o === "n" ? (a.y += r, a.height -= r) : o === "ne" ? (a.y += r, a.width -= r, a.height -= r) : o === "sw" ? (a.x -= r, a.width += r, a.height += r) : o === "s" ? a.height += r : o === "se" && (a.width += r, a.height += r)), a;
}
const ot = { capture: !0, passive: !1 };
let $i = 0;
const je = class le extends Zn {
  constructor() {
    super(...arguments), this.docMoveBound = !1, this.mouseDownOnCrop = !1, this.dragStarted = !1, this.evData = {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }, this.componentRef = pr(), this.mediaRef = pr(), this.initChangeCalled = !1, this.instanceId = `rc-${$i++}`, this.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, this.onCropPointerDown = (t) => {
      const { crop: r, disabled: o } = this.props, a = this.getBox();
      if (!r)
        return;
      const i = Ee(r, a.width, a.height);
      if (o)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const l = t.target.dataset.ord, p = !!l;
      let f = t.clientX, c = t.clientY, h = i.x, g = i.y;
      if (l) {
        const w = t.clientX - a.x, b = t.clientY - a.y;
        let R = 0, M = 0;
        l === "ne" || l == "e" ? (R = w - (i.x + i.width), M = b - i.y, h = i.x, g = i.y + i.height) : l === "se" || l === "s" ? (R = w - (i.x + i.width), M = b - (i.y + i.height), h = i.x, g = i.y) : l === "sw" || l == "w" ? (R = w - i.x, M = b - (i.y + i.height), h = i.x + i.width, g = i.y) : (l === "nw" || l == "n") && (R = w - i.x, M = b - i.y, h = i.x + i.width, g = i.y + i.height), f = h + a.x + R, c = g + a.y + M;
      }
      this.evData = {
        startClientX: f,
        startClientY: c,
        startCropX: h,
        startCropY: g,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: p,
        ord: l
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }, this.onComponentPointerDown = (t) => {
      const { crop: r, disabled: o, locked: a, keepSelection: i, onChange: l } = this.props, p = this.getBox();
      if (o || a || i && r)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const f = t.clientX - p.x, c = t.clientY - p.y, h = {
        unit: "px",
        x: f,
        y: c,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: t.clientX,
        startClientY: t.clientY,
        startCropX: f,
        startCropY: c,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, l(Ee(h, p.width, p.height), nt(h, p.width, p.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }, this.onDocPointerMove = (t) => {
      const { crop: r, disabled: o, onChange: a, onDragStart: i } = this.props, l = this.getBox();
      if (o || !r || !this.mouseDownOnCrop)
        return;
      t.cancelable && t.preventDefault(), this.dragStarted || (this.dragStarted = !0, i && i(t));
      const { evData: p } = this;
      p.clientX = t.clientX, p.clientY = t.clientY;
      let f;
      p.isResize ? f = this.resizeCrop() : f = this.dragCrop(), on(r, f) || a(
        Ee(f, l.width, l.height),
        nt(f, l.width, l.height)
      );
    }, this.onComponentKeyDown = (t) => {
      const { crop: r, disabled: o, onChange: a, onComplete: i } = this.props;
      if (o)
        return;
      const l = t.key;
      let p = !1;
      if (!r)
        return;
      const f = this.getBox(), c = this.makePixelCrop(f), h = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? le.nudgeStepLarge : t.shiftKey ? le.nudgeStepMedium : le.nudgeStep;
      if (l === "ArrowLeft" ? (c.x -= h, p = !0) : l === "ArrowRight" ? (c.x += h, p = !0) : l === "ArrowUp" ? (c.y -= h, p = !0) : l === "ArrowDown" && (c.y += h, p = !0), p) {
        t.cancelable && t.preventDefault(), c.x = rt(c.x, 0, f.width - c.width), c.y = rt(c.y, 0, f.height - c.height);
        const g = Ee(c, f.width, f.height), w = nt(c, f.width, f.height);
        a(g, w), i && i(g, w);
      }
    }, this.onHandlerKeyDown = (t, r) => {
      const {
        aspect: o = 0,
        crop: a,
        disabled: i,
        minWidth: l = 0,
        minHeight: p = 0,
        maxWidth: f,
        maxHeight: c,
        onChange: h,
        onComplete: g
      } = this.props, w = this.getBox();
      if (i || !a)
        return;
      if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight")
        t.stopPropagation(), t.preventDefault();
      else
        return;
      const b = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? le.nudgeStepLarge : t.shiftKey ? le.nudgeStepMedium : le.nudgeStep, R = Ee(a, w.width, w.height), M = ji(R, t.key, b, r), B = an(
        M,
        o,
        r,
        w.width,
        w.height,
        l,
        p,
        f,
        c
      );
      if (!on(a, B)) {
        const I = nt(B, w.width, w.height);
        h(B, I), g && g(B, I);
      }
    }, this.onDocPointerDone = (t) => {
      const { crop: r, disabled: o, onComplete: a, onDragEnd: i } = this.props, l = this.getBox();
      this.unbindDocMove(), !(o || !r) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, i && i(t), a && a(Ee(r, l.width, l.height), nt(r, l.width, l.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }, this.onDragFocus = () => {
      var t;
      (t = this.componentRef.current) == null || t.scrollTo(0, 0);
    };
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const t = this.mediaRef.current;
    if (!t)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: r, y: o, width: a, height: i } = t.getBoundingClientRect();
    return { x: r, y: o, width: a, height: i };
  }
  componentDidUpdate(t) {
    const { crop: r, onComplete: o } = this.props;
    if (o && !t.crop && r) {
      const { width: a, height: i } = this.getBox();
      a && i && o(Ee(r, a, i), nt(r, a, i));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, ot), this.document.addEventListener("pointerup", this.onDocPointerDone, ot), this.document.addEventListener("pointercancel", this.onDocPointerDone, ot), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, ot), this.document.removeEventListener("pointerup", this.onDocPointerDone, ot), this.document.removeEventListener("pointercancel", this.onDocPointerDone, ot), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: t } = this.props;
    if (t)
      return {
        top: `${t.y}${t.unit}`,
        left: `${t.x}${t.unit}`,
        width: `${t.width}${t.unit}`,
        height: `${t.height}${t.unit}`
      };
  }
  dragCrop() {
    const { evData: t } = this, r = this.getBox(), o = this.makePixelCrop(r), a = t.clientX - t.startClientX, i = t.clientY - t.startClientY;
    return o.x = rt(t.startCropX + a, 0, r.width - o.width), o.y = rt(t.startCropY + i, 0, r.height - o.height), o;
  }
  getPointRegion(t, r, o, a) {
    const { evData: i } = this, l = i.clientX - t.x, p = i.clientY - t.y;
    let f;
    a && r ? f = r === "nw" || r === "n" || r === "ne" : f = p < i.startCropY;
    let c;
    return o && r ? c = r === "nw" || r === "w" || r === "sw" : c = l < i.startCropX, c ? f ? "nw" : "sw" : f ? "ne" : "se";
  }
  resolveMinDimensions(t, r, o = 0, a = 0) {
    const i = Math.min(o, t.width), l = Math.min(a, t.height);
    return !r || !i && !l ? [i, l] : r > 1 ? i ? [i, i / r] : [l * r, l] : l ? [l * r, l] : [i, i / r];
  }
  resizeCrop() {
    const { evData: t } = this, { aspect: r = 0, maxWidth: o, maxHeight: a } = this.props, i = this.getBox(), [l, p] = this.resolveMinDimensions(i, r, this.props.minWidth, this.props.minHeight);
    let f = this.makePixelCrop(i);
    const c = this.getPointRegion(i, t.ord, l, p), h = t.ord || c;
    let g = t.clientX - t.startClientX, w = t.clientY - t.startClientY;
    (l && h === "nw" || h === "w" || h === "sw") && (g = Math.min(g, -l)), (p && h === "nw" || h === "n" || h === "ne") && (w = Math.min(w, -p));
    const b = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    c === "ne" ? (b.x = t.startCropX, b.width = g, r ? (b.height = b.width / r, b.y = t.startCropY - b.height) : (b.height = Math.abs(w), b.y = t.startCropY - b.height)) : c === "se" ? (b.x = t.startCropX, b.y = t.startCropY, b.width = g, r ? b.height = b.width / r : b.height = w) : c === "sw" ? (b.x = t.startCropX + g, b.y = t.startCropY, b.width = Math.abs(g), r ? b.height = b.width / r : b.height = w) : c === "nw" && (b.x = t.startCropX + g, b.width = Math.abs(g), r ? (b.height = b.width / r, b.y = t.startCropY - b.height) : (b.height = Math.abs(w), b.y = t.startCropY + w));
    const R = an(
      b,
      r,
      c,
      i.width,
      i.height,
      l,
      p,
      o,
      a
    );
    return r || le.xyOrds.indexOf(h) > -1 ? f = R : le.xOrds.indexOf(h) > -1 ? (f.x = R.x, f.width = R.width) : le.yOrds.indexOf(h) > -1 && (f.y = R.y, f.height = R.height), f.x = rt(f.x, 0, i.width - f.width), f.y = rt(f.y, 0, i.height - f.height), f;
  }
  renderCropSelection() {
    const {
      ariaLabels: t = le.defaultProps.ariaLabels,
      disabled: r,
      locked: o,
      renderSelectionAddon: a,
      ruleOfThirds: i,
      crop: l
    } = this.props, p = this.getCropStyle();
    if (l)
      return /* @__PURE__ */ $.createElement(
        "div",
        {
          style: p,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !r && !o && /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": t.nwDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": t.nDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": t.neDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": t.eDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": t.seDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": t.sDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": t.swDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ $.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": t.wDragHandle,
            onKeyDown: (f) => this.onHandlerKeyDown(f, "w"),
            role: "button"
          }
        )),
        a && /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (f) => f.stopPropagation() }, a(this.state)),
        i && /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ $.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(t) {
    const r = { ...Lt, ...this.props.crop || {} };
    return Ee(r, t.width, t.height);
  }
  render() {
    const { aspect: t, children: r, circularCrop: o, className: a, crop: i, disabled: l, locked: p, style: f, ruleOfThirds: c } = this.props, { cropIsActive: h, newCropIsBeingDrawn: g } = this.state, w = i ? this.renderCropSelection() : null, b = Ei(
      "ReactCrop",
      a,
      h && "ReactCrop--active",
      l && "ReactCrop--disabled",
      p && "ReactCrop--locked",
      g && "ReactCrop--new-crop",
      i && t && "ReactCrop--fixed-aspect",
      i && o && "ReactCrop--circular-crop",
      i && c && "ReactCrop--rule-of-thirds",
      !this.dragStarted && i && !i.width && !i.height && "ReactCrop--invisible-crop",
      o && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ $.createElement("div", { ref: this.componentRef, className: b, style: f }, /* @__PURE__ */ $.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, r), i ? /* @__PURE__ */ $.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ $.createElement("defs", null, /* @__PURE__ */ $.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ $.createElement("rect", { width: "100%", height: "100%", fill: "white" }), o ? /* @__PURE__ */ $.createElement(
      "ellipse",
      {
        cx: `${i.x + i.width / 2}${i.unit}`,
        cy: `${i.y + i.height / 2}${i.unit}`,
        rx: `${i.width / 2}${i.unit}`,
        ry: `${i.height / 2}${i.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ $.createElement(
      "rect",
      {
        x: `${i.x}${i.unit}`,
        y: `${i.y}${i.unit}`,
        width: `${i.width}${i.unit}`,
        height: `${i.height}${i.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ $.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, w);
  }
};
je.xOrds = ["e", "w"], je.yOrds = ["n", "s"], je.xyOrds = ["nw", "ne", "se", "sw"], je.nudgeStep = 1, je.nudgeStepMedium = 10, je.nudgeStepLarge = 100, je.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
let Pi = je;
var Ti = "Expected a function", Pn = "__lodash_hash_undefined__", Tn = 1 / 0, Ii = "[object Function]", ki = "[object GeneratorFunction]", Fi = "[object Symbol]", Ai = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Mi = /^\w*$/, Ui = /^\./, Ni = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Li = /[\\^$.*+?()[\]{}|]/g, Bi = /\\(\\)?/g, Hi = /^\[object .+?Constructor\]$/, zi = typeof window == "object" && window && window.Object === Object && window, Yi = typeof self == "object" && self && self.Object === Object && self, Pr = zi || Yi || Function("return this")();
function Ki(e, t) {
  return e == null ? void 0 : e[t];
}
function Wi(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var Vi = Array.prototype, Xi = Function.prototype, In = Object.prototype, lr = Pr["__core-js_shared__"], sn = function() {
  var e = /[^.]+$/.exec(lr && lr.keys && lr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), kn = Xi.toString, Tr = In.hasOwnProperty, Fn = In.toString, Gi = RegExp(
  "^" + kn.call(Tr).replace(Li, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), cn = Pr.Symbol, qi = Vi.splice, Ji = An(Pr, "Map"), Ot = An(Object, "create"), ln = cn ? cn.prototype : void 0, un = ln ? ln.toString : void 0;
function Ke(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function Qi() {
  this.__data__ = Ot ? Ot(null) : {};
}
function Zi(e) {
  return this.has(e) && delete this.__data__[e];
}
function es(e) {
  var t = this.__data__;
  if (Ot) {
    var r = t[e];
    return r === Pn ? void 0 : r;
  }
  return Tr.call(t, e) ? t[e] : void 0;
}
function ts(e) {
  var t = this.__data__;
  return Ot ? t[e] !== void 0 : Tr.call(t, e);
}
function rs(e, t) {
  var r = this.__data__;
  return r[e] = Ot && t === void 0 ? Pn : t, this;
}
Ke.prototype.clear = Qi;
Ke.prototype.delete = Zi;
Ke.prototype.get = es;
Ke.prototype.has = ts;
Ke.prototype.set = rs;
function lt(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function ns() {
  this.__data__ = [];
}
function os(e) {
  var t = this.__data__, r = Vt(t, e);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : qi.call(t, r, 1), !0;
}
function as(e) {
  var t = this.__data__, r = Vt(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function is(e) {
  return Vt(this.__data__, e) > -1;
}
function ss(e, t) {
  var r = this.__data__, o = Vt(r, e);
  return o < 0 ? r.push([e, t]) : r[o][1] = t, this;
}
lt.prototype.clear = ns;
lt.prototype.delete = os;
lt.prototype.get = as;
lt.prototype.has = is;
lt.prototype.set = ss;
function Ve(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function cs() {
  this.__data__ = {
    hash: new Ke(),
    map: new (Ji || lt)(),
    string: new Ke()
  };
}
function ls(e) {
  return Xt(this, e).delete(e);
}
function us(e) {
  return Xt(this, e).get(e);
}
function fs(e) {
  return Xt(this, e).has(e);
}
function ps(e, t) {
  return Xt(this, e).set(e, t), this;
}
Ve.prototype.clear = cs;
Ve.prototype.delete = ls;
Ve.prototype.get = us;
Ve.prototype.has = fs;
Ve.prototype.set = ps;
function Vt(e, t) {
  for (var r = e.length; r--; )
    if (Cs(e[r][0], t))
      return r;
  return -1;
}
function hs(e, t) {
  t = vs(t, e) ? [t] : ys(t);
  for (var r = 0, o = t.length; e != null && r < o; )
    e = e[_s(t[r++])];
  return r && r == o ? e : void 0;
}
function ds(e) {
  if (!Un(e) || bs(e))
    return !1;
  var t = Ds(e) || Wi(e) ? Gi : Hi;
  return t.test(xs(e));
}
function gs(e) {
  if (typeof e == "string")
    return e;
  if (kr(e))
    return un ? un.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Tn ? "-0" : t;
}
function ys(e) {
  return Mn(e) ? e : ws(e);
}
function Xt(e, t) {
  var r = e.__data__;
  return ms(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function An(e, t) {
  var r = Ki(e, t);
  return ds(r) ? r : void 0;
}
function vs(e, t) {
  if (Mn(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || kr(e) ? !0 : Mi.test(e) || !Ai.test(e) || t != null && e in Object(t);
}
function ms(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function bs(e) {
  return !!sn && sn in e;
}
var ws = Ir(function(e) {
  e = Os(e);
  var t = [];
  return Ui.test(e) && t.push(""), e.replace(Ni, function(r, o, a, i) {
    t.push(a ? i.replace(Bi, "$1") : o || r);
  }), t;
});
function _s(e) {
  if (typeof e == "string" || kr(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Tn ? "-0" : t;
}
function xs(e) {
  if (e != null) {
    try {
      return kn.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function Ir(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError(Ti);
  var r = function() {
    var o = arguments, a = t ? t.apply(this, o) : o[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var l = e.apply(this, o);
    return r.cache = i.set(a, l), l;
  };
  return r.cache = new (Ir.Cache || Ve)(), r;
}
Ir.Cache = Ve;
function Cs(e, t) {
  return e === t || e !== e && t !== t;
}
var Mn = Array.isArray;
function Ds(e) {
  var t = Un(e) ? Fn.call(e) : "";
  return t == Ii || t == ki;
}
function Un(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Ss(e) {
  return !!e && typeof e == "object";
}
function kr(e) {
  return typeof e == "symbol" || Ss(e) && Fn.call(e) == Fi;
}
function Os(e) {
  return e == null ? "" : gs(e);
}
function Rs(e, t, r) {
  var o = e == null ? void 0 : hs(e, t);
  return o === void 0 ? r : o;
}
var Es = Rs;
const Ct = /* @__PURE__ */ Cr(Es);
var js = { exports: {} };
(function(e) {
  (function(t) {
    var r = t.HTMLCanvasElement && t.HTMLCanvasElement.prototype, o = t.Blob && function() {
      try {
        return !!new Blob();
      } catch {
        return !1;
      }
    }(), a = o && t.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch {
        return !1;
      }
    }(), i = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || t.MSBlobBuilder, l = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, p = (o || i) && t.atob && t.ArrayBuffer && t.Uint8Array && function(f) {
      var c, h, g, w, b, R, M, B, I;
      if (c = f.match(l), !c)
        throw new Error("invalid data URI");
      for (h = c[2] ? c[1] : "text/plain" + (c[3] || ";charset=US-ASCII"), g = !!c[4], w = f.slice(c[0].length), g ? b = atob(w) : b = decodeURIComponent(w), R = new ArrayBuffer(b.length), M = new Uint8Array(R), B = 0; B < b.length; B += 1)
        M[B] = b.charCodeAt(B);
      return o ? new Blob([a ? M : R], {
        type: h
      }) : (I = new i(), I.append(R), I.getBlob(h));
    };
    t.HTMLCanvasElement && !r.toBlob && (r.mozGetAsFile ? r.toBlob = function(f, c, h) {
      var g = this;
      setTimeout(function() {
        h && r.toDataURL && p ? f(p(g.toDataURL(c, h))) : f(g.mozGetAsFile("blob", c));
      });
    } : r.toDataURL && p && (r.msToBlob ? r.toBlob = function(f, c, h) {
      var g = this;
      setTimeout(function() {
        (c && c !== "image/png" || h) && r.toDataURL && p ? f(p(g.toDataURL(c, h))) : f(g.msToBlob(c));
      });
    } : r.toBlob = function(f, c, h) {
      var g = this;
      setTimeout(function() {
        f(p(g.toDataURL(c, h)));
      });
    })), e.exports ? e.exports = p : t.dataURLtoBlob = p;
  })(window);
})(js);
class Bt {
  constructor(t, r = { keepHistory: 1 }) {
    const { keepHistory: o } = r;
    this.keepHistory = Number.isInteger(o) && o > 1 ? o : 1, this.history = [], this.update(t);
  }
  reset(t) {
    this.clear(), this.update(t);
  }
  update(t) {
    for (t && this.history.push({
      blob: t,
      fileUrl: window.URL.createObjectURL(t)
    }); this.history.length > this.keepHistory; ) {
      const { fileUrl: r } = this.history.shift();
      window.URL.revokeObjectURL(r);
    }
  }
  async updateFromCanvas(t, r = "image/png", o = 1) {
    const a = await Bt.canvasToBlob(t, r, o);
    this.update(a);
  }
  static async canvasToBlob(t, r = "image/png", o = 1) {
    return new Promise((a, i) => {
      t.toBlob((l) => {
        if (!l) {
          i(new Error("Canvas is empty"));
          return;
        }
        a(l);
      }, r, o);
    });
  }
  getUrl() {
    return Ct(this.history[this.history.length - 1], "fileUrl");
  }
  getBlob() {
    return Ct(this.history[this.history.length - 1], "blob");
  }
  getType() {
    return Ct(this.history[this.history.length - 1], "blob.type");
  }
  hasPreviousHistory() {
    return this.history.length > 1;
  }
  pop() {
    return this.history.pop();
  }
  clear() {
    for (; this.history.length > 0; ) {
      const { fileUrl: t } = this.history.shift();
      window.URL.revokeObjectURL(t);
    }
  }
}
const kt = (e) => Math.round(e * 16) / 16;
var Ft;
let Nn = (Ft = class extends Ht {
  constructor(r) {
    super(r);
    H(this, "afterChange", () => {
      const { onChange: r } = this.props;
      if (r) {
        const { crop: o, percentCrop: a } = this.state;
        r({
          pixelCrop: o,
          percentCrop: a,
          blob: this.blobManager.getBlob()
        });
      }
    });
    H(this, "save", () => {
      const { onSave: r } = this.props;
      if (r) {
        const { crop: o, percentCrop: a } = this.state;
        r({
          pixelCrop: o,
          percentCrop: a,
          blob: this.blobManager.getBlob()
        });
      }
    });
    H(this, "cancel", () => {
      const { onCancel: r } = this.props;
      r && r();
    });
    H(this, "onCropComplete", (r, o) => {
      this.setState({
        crop: r,
        percentCrop: o
      });
    });
    H(this, "onCropChange", (r, o) => {
      this.setState({
        crop: r,
        percentCrop: o
      });
    });
    H(this, "onImageLoaded", (r) => {
      this.clearCropSelection();
      const { scrollIntoView: o } = this.props;
      o && window.scrollTo(0, this.ref.current.offsetTop);
    });
    H(this, "loadImage", (r, o) => {
      this.clearCropSelection(), r && (this.blobManager.reset(r), this.setState({
        src: this.blobManager.getUrl(),
        canUndo: this.blobManager.hasPreviousHistory()
      }, o));
    });
    H(this, "clearCropSelection", () => {
      this.setState({
        crop: void 0,
        percentCrop: void 0
      });
    });
    H(this, "rotate", (r = "right") => {
      this.clearCropSelection();
      const o = new Image();
      o.onload = async () => {
        const a = document.createElement("canvas");
        a.width = o.height, a.height = o.width;
        const i = a.getContext("2d");
        r === "right" ? (i.rotate(90 * Math.PI / 180), i.translate(0, -a.width)) : (i.rotate(-90 * Math.PI / 180), i.translate(-a.height, 0)), i.drawImage(o, 0, 0), await this.blobManager.updateFromCanvas(a, this.blobManager.getType()), this.setState({
          src: this.blobManager.getUrl(),
          canUndo: this.blobManager.hasPreviousHistory()
        }, this.afterChange);
      }, o.src = this.state.src;
    });
    H(this, "crop", () => {
      const { cropFunction: r } = this.props, { crop: o, percentCrop: a } = this.state, i = new Image();
      i.onload = async () => {
        const l = document.createElement("canvas"), p = i.naturalWidth || i.width, f = i.naturalHeight || i.height, c = kt(a.x / 100 * p), h = kt(a.y / 100 * f), g = kt(a.width / 100 * p), w = kt(a.height / 100 * f);
        if (l.width = g, l.height = w, l.getContext("2d").drawImage(
          i,
          c,
          h,
          g,
          w,
          0,
          0,
          g,
          w
        ), this.clearCropSelection(), r) {
          const R = await Bt.canvasToBlob(l, this.blobManager.getType());
          r({
            pixelCrop: o,
            percentCrop: a,
            blob: R
          });
        } else
          await this.blobManager.updateFromCanvas(l, this.blobManager.getType()), this.setState({
            src: this.blobManager.getUrl(),
            canUndo: this.blobManager.hasPreviousHistory()
          }, this.afterChange);
      }, i.src = this.blobManager.getUrl();
    });
    H(this, "undo", () => {
      this.clearCropSelection(), this.blobManager.pop(), this.setState({
        src: this.blobManager.getUrl(),
        canUndo: this.blobManager.hasPreviousHistory()
      }, this.afterChange);
    });
    H(this, "isCropValid", () => {
      const { crop: r } = this.state;
      return Ct(r, "width", 0) > 0 && Ct(r, "height", 0) > 0;
    });
    this.ref = pr(), this.blobManager = new Bt(null, { keepHistory: 3 });
    const { cropAspect: o } = r;
    this.state = {
      src: null,
      aspect: o,
      crop: void 0,
      percentCrop: void 0,
      canUndo: !1
    };
  }
  componentDidMount() {
    const { file: r, cropAspect: o } = this.props;
    this.setState({
      cropAspect: o
    }), this.loadImage(r);
  }
  componentDidUpdate(r) {
    const { file: o } = r, { file: a } = this.props;
    o !== a && this.loadImage(a);
  }
  componentWillUnmount() {
    this.blobManager.clear();
  }
  render() {
    const { className: r, rsx: o, ruleOfThirds: a, renderHeader: i, renderControls: l } = this.props, { src: p, crop: f, canUndo: c, aspect: h } = this.state;
    return p ? /* @__PURE__ */ E.jsxs("div", { className: r || "image-cropper", ref: this.ref, children: [
      i ? i({ save: this.save, cancel: this.cancel }) : /* @__PURE__ */ E.jsxs("div", { className: "cropper-header", children: [
        /* @__PURE__ */ E.jsx("div", { className: "cropper-title", children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.title || "Edit your image" } }) }),
        /* @__PURE__ */ E.jsxs("div", { className: "cropper-actions", children: [
          /* @__PURE__ */ E.jsx("button", { onClick: this.save, children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnSave || "Save" } }) }),
          /* @__PURE__ */ E.jsx("button", { onClick: this.cancel, children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnDiscard || "Discard changes" } }) })
        ] })
      ] }),
      /* @__PURE__ */ E.jsx("div", { className: "cropper-container", children: /* @__PURE__ */ E.jsx(
        Pi,
        {
          aspect: h,
          crop: f,
          onComplete: this.onCropComplete,
          onChange: this.onCropChange,
          className: "cropper",
          ruleOfThirds: a,
          children: /* @__PURE__ */ E.jsx("img", { src: p, alt: "Crop this", onLoad: this.onImageLoaded })
        }
      ) }),
      l ? l({ rotate: this.rotate, crop: this.crop, isCropValid: this.isCropValid(), undo: this.undo, canUndo: c }) : /* @__PURE__ */ E.jsxs("div", { className: "cropper-controls", children: [
        /* @__PURE__ */ E.jsx("button", { onClick: () => this.rotate("left"), children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnRotateLeft || "Rotate Left" } }) }),
        /* @__PURE__ */ E.jsx("button", { onClick: this.crop, disabled: !this.isCropValid(), children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnCrop || "Crop" } }) }),
        /* @__PURE__ */ E.jsx("button", { onClick: () => this.rotate("right"), children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnRotateRight || "Rotate Right" } }) }),
        /* @__PURE__ */ E.jsx("button", { onClick: this.undo, disabled: !c, children: /* @__PURE__ */ E.jsx("span", { dangerouslySetInnerHTML: { __html: o.btnUndo || "Undo" } }) })
      ] })
    ] }) : /* @__PURE__ */ E.jsx("div", { children: "No image" });
  }
}, H(Ft, "propTypes", {
  file: C.func,
  // small hack, it should be PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.instanceOf(Blob)]), but its not working in ssr
  cropAspect: C.number,
  onChange: C.func,
  onSave: C.func,
  onCancel: C.func,
  scrollIntoView: C.bool,
  className: C.string,
  rsx: C.object,
  ruleOfThirds: C.bool,
  cropFunction: C.func,
  renderHeader: C.func,
  renderControls: C.func
}), H(Ft, "defaultProps", {
  scrollIntoView: !1,
  rsx: {},
  ruleOfThirds: !1
}), Ft);
var $s = "Expected a function", Ln = "__lodash_hash_undefined__", Ps = "[object Function]", Ts = "[object GeneratorFunction]", Is = /[\\^$.*+?()[\]{}|]/g, ks = /^\[object .+?Constructor\]$/, Fs = typeof window == "object" && window && window.Object === Object && window, As = typeof self == "object" && self && self.Object === Object && self, Bn = Fs || As || Function("return this")();
function Ms(e, t) {
  return e == null ? void 0 : e[t];
}
function Us(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var Ns = Array.prototype, Ls = Function.prototype, Hn = Object.prototype, ur = Bn["__core-js_shared__"], fn = function() {
  var e = /[^.]+$/.exec(ur && ur.keys && ur.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), zn = Ls.toString, Fr = Hn.hasOwnProperty, Bs = Hn.toString, Hs = RegExp(
  "^" + zn.call(Fr).replace(Is, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), zs = Ns.splice, Ys = Yn(Bn, "Map"), Rt = Yn(Object, "create");
function We(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function Ks() {
  this.__data__ = Rt ? Rt(null) : {};
}
function Ws(e) {
  return this.has(e) && delete this.__data__[e];
}
function Vs(e) {
  var t = this.__data__;
  if (Rt) {
    var r = t[e];
    return r === Ln ? void 0 : r;
  }
  return Fr.call(t, e) ? t[e] : void 0;
}
function Xs(e) {
  var t = this.__data__;
  return Rt ? t[e] !== void 0 : Fr.call(t, e);
}
function Gs(e, t) {
  var r = this.__data__;
  return r[e] = Rt && t === void 0 ? Ln : t, this;
}
We.prototype.clear = Ks;
We.prototype.delete = Ws;
We.prototype.get = Vs;
We.prototype.has = Xs;
We.prototype.set = Gs;
function ut(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function qs() {
  this.__data__ = [];
}
function Js(e) {
  var t = this.__data__, r = Gt(t, e);
  if (r < 0)
    return !1;
  var o = t.length - 1;
  return r == o ? t.pop() : zs.call(t, r, 1), !0;
}
function Qs(e) {
  var t = this.__data__, r = Gt(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Zs(e) {
  return Gt(this.__data__, e) > -1;
}
function ec(e, t) {
  var r = this.__data__, o = Gt(r, e);
  return o < 0 ? r.push([e, t]) : r[o][1] = t, this;
}
ut.prototype.clear = qs;
ut.prototype.delete = Js;
ut.prototype.get = Qs;
ut.prototype.has = Zs;
ut.prototype.set = ec;
function Xe(e) {
  var t = -1, r = e ? e.length : 0;
  for (this.clear(); ++t < r; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
function tc() {
  this.__data__ = {
    hash: new We(),
    map: new (Ys || ut)(),
    string: new We()
  };
}
function rc(e) {
  return qt(this, e).delete(e);
}
function nc(e) {
  return qt(this, e).get(e);
}
function oc(e) {
  return qt(this, e).has(e);
}
function ac(e, t) {
  return qt(this, e).set(e, t), this;
}
Xe.prototype.clear = tc;
Xe.prototype.delete = rc;
Xe.prototype.get = nc;
Xe.prototype.has = oc;
Xe.prototype.set = ac;
function Gt(e, t) {
  for (var r = e.length; r--; )
    if (uc(e[r][0], t))
      return r;
  return -1;
}
function ic(e) {
  if (!Kn(e) || cc(e))
    return !1;
  var t = fc(e) || Us(e) ? Hs : ks;
  return t.test(lc(e));
}
function qt(e, t) {
  var r = e.__data__;
  return sc(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Yn(e, t) {
  var r = Ms(e, t);
  return ic(r) ? r : void 0;
}
function sc(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function cc(e) {
  return !!fn && fn in e;
}
function lc(e) {
  if (e != null) {
    try {
      return zn.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function Ar(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError($s);
  var r = function() {
    var o = arguments, a = t ? t.apply(this, o) : o[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var l = e.apply(this, o);
    return r.cache = i.set(a, l), l;
  };
  return r.cache = new (Ar.Cache || Xe)(), r;
}
Ar.Cache = Xe;
function uc(e, t) {
  return e === t || e !== e && t !== t;
}
function fc(e) {
  var t = Kn(e) ? Bs.call(e) : "";
  return t == Ps || t == Ts;
}
function Kn(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
var pc = Ar;
const hc = /* @__PURE__ */ Cr(pc), dc = hc((e) => e instanceof File || e instanceof Blob ? window.URL.createObjectURL(e) : typeof e == "string" ? e : null);
class gc extends Ht {
  constructor() {
    super(...arguments);
    H(this, "discard", (r) => {
      r.stopPropagation();
      const { onDiscard: o, loading: a } = this.props;
      o && !a && o();
    });
    H(this, "click", (r) => {
      const { onClick: o, loading: a } = this.props;
      o && !a && o(r);
    });
  }
  componentDidUpdate(r) {
    const { src: o } = r, { src: a } = this.props;
    a !== o && window.URL.revokeObjectURL(a);
  }
  render() {
    const { src: r, loading: o } = this.props;
    return /* @__PURE__ */ E.jsxs("div", { onClick: this.click, className: "ImageCropper-Thumbnail", children: [
      o && /* @__PURE__ */ E.jsx("div", { className: "ImageCropper-Thumbnail-Loader", children: "Loading..." }),
      /* @__PURE__ */ E.jsx("button", { onClick: this.discard, disabled: o, children: "X" }),
      /* @__PURE__ */ E.jsx("img", { src: dc(r), style: { maxWidth: 200 } })
    ] });
  }
}
var fr;
let yc = (fr = class extends Ht {
  constructor(r) {
    super(r);
    H(this, "onFileSelected", (r, o) => {
      r.length > 0 && this.setState((a) => {
        const { files: i } = a, l = Object.keys(i).length;
        return r.forEach((p, f) => {
          i[ca()] = {
            file: p,
            index: l + f
          };
        }), {
          files: i
        };
      });
    });
    H(this, "uploadFile", async (r) => {
      const { upload: o } = this.props, { files: a } = this.state, { file: i, index: l } = a[r];
      i && (await o({ file: i, index: l }), this.setState({
        files: {
          ...a,
          [r]: {
            ...a[r],
            uploading: !1
          }
        }
      }));
    });
    this.state = {
      files: {},
      selectedFileUuid: null
    };
  }
  render() {
    const { files: r, selectedFileUuid: o } = this.state, a = r[o];
    return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
      /* @__PURE__ */ E.jsx(
        Dr,
        {
          onFileSelected: this.onFileSelected
        }
      ),
      /* @__PURE__ */ E.jsx("div", { children: Object.entries(r).map(([i, { file: l, uploading: p }]) => /* @__PURE__ */ E.jsx(
        gc,
        {
          src: l,
          loading: p,
          onClick: () => this.setState({ selectedFileUuid: i }),
          onDiscard: () => this.setState({ files: Ri(r, [i]) })
        },
        i
      )) }),
      /* @__PURE__ */ E.jsx("div", { children: a && /* @__PURE__ */ E.jsx(
        Nn,
        {
          scrollIntoView: !0,
          file: a.file,
          onCancel: () => {
            this.setState({ selectedFileUuid: null });
          },
          onSave: ({ blob: i }) => {
            this.setState({
              selectedFileUuid: null,
              files: {
                ...r,
                [o]: {
                  ...r[o],
                  file: i,
                  uploading: !0
                }
              }
            }, () => this.uploadFile(o));
          }
        }
      ) })
    ] });
  }
}, H(fr, "propTypes", {
  upload: C.func.isRequired
}), fr);
const Wn = async (e, t = "image/png", r = 1) => new Promise((o, a) => {
  const i = document.createElement("canvas");
  console.log(e.naturalWidth, e.width, e.naturalHeight, e.height), i.width = e.naturalWidth || e.width, i.height = e.naturalHeight || e.height, i.getContext("2d").drawImage(e, 0, 0), i.toBlob((p) => {
    if (!p) {
      a(new Error("Canvas is empty"));
      return;
    }
    o(p);
  }, t, r);
}), vc = async (e, t = "image/png", r = 1) => new Promise((o, a) => {
  const i = new Image();
  i.onload = () => {
    Wn(i, t, r).then(o).catch(a);
  }, i.src = e;
}), Cc = Dr, Dc = yc, Sc = Nn, Oc = Wn, Rc = vc;
export {
  Sc as ImageCropper,
  Cc as ImageSelector,
  Dc as ImageUploader,
  Oc as imgToBlob,
  Rc as urlToBlob
};
